<template>
  <div>
    <v-breadcrumbs :items="crumbs"></v-breadcrumbs>
    <base-loader :isLoading="isLoading"></base-loader>
    <v-row>
      <v-col md="6">
        <v-card>
          <v-card-text>
            <h4 class="text-md-h4 primary--text mb-5">
              {{ `${isEdit ? "Edit" : "New"} Organisation` }}
            </h4>
            <v-form ref="organisationForm" @submit.prevent="save()">
              <v-row>
                <v-col md="12">
                  <v-text-field
                    v-model="organisationModel.name"
                    label="Organisation Name"
                    required
                    outlined
                    :rules="[(v) => !!v || 'Organisation Name is required']"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-btn type="submit" color="success">Save</v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { gql } from "apollo-boost";
import { Organisation } from "@/models/Organisation";
export default {
  data() {
    return {
      isEdit: false,
      isLoading: false,
      organisationModel: new Organisation(),
      me: "",
      search: null,
    };
  },
  created() {
    this.isEdit = this.$route.params.id != 0;
    this.isLoading = this.isEdit ? true : false;
  },
  computed: {
    crumbs() {
      return [
        {
          text: "Organisations",
          disabled: false,
          href: "/admin/organisations",
        },
        {
          text: "Organisation Detail",
          disabled: false,
          href: `/admin/organisation/${this.$route.params.id}`,
        },
        {
          text: `${this.isEdit ? "Edit" : "New"} Organisation`,
          disabled: true,
        },
      ];
    },
  },
  watch: {},
  apollo: {
    me: gql`
      query {
        me {
          id
        }
      }
    `,
    organisation: {
      query: gql`
        query Organisation($id: ID!) {
          organisation(id: $id) {
            id
            name
          }
        }
      `,
      fetchPolicy: "network-only",
      skip() {
        return !this.isEdit;
      },
      variables() {
        const self = this;
        return {
          id: self.$route.params.id,
        };
      },
      result(response, key) {
        this.isLoading = false;
        this.organisationModel.id = this.organisation.id;
        this.organisationModel.name = this.organisation.name;
      },
    },
  },
  methods: {
    async save() {
      this.isLoading = true;
      const self = this;
      if (!self.$refs.organisationForm.validate()) {
        self.$swal("Error", "Validation failed", "error");
        self.isLoading = false;
        return;
      }
      if (self.isEdit) {
        // update
        await this.updateOrganisation()
          .then(() => {
            this.$swal("Success!", "Organisation was updated", "success");
          })
          .catch((e) => {
            this.$swal(
              "Error!",
              "something went wrong when trying to update the organisation, check data and try again later!",
              "error"
            );
          });
      } else {
        // create
        await this.createOrganisation()
          .then(() => {
            this.$swal("Success!", "Organisation was created", "success");
            window.location.href = `/admin/organisation/${self.organisationModel.id}/edit`;
          })
          .catch((e) => {
            this.$swal(
              "Error!",
              `Something went wrong when creating the organisation, check data and try again later!`,
              "error"
            );
          });
      }
      this.isLoading = false;
    },
    async updateOrganisation() {
      const self = this;
      try {
        const response = await self.$apollo.mutate({
          mutation: gql`
            mutation update($organisation: OrganisationUpdateInput!) {
              updateOrganisation(organisation: $organisation) {
                id
                updated
              }
            }
          `,
          variables: {
            organisation: {
              id: self.organisationModel.id,
              name: self.organisationModel.name,
              createdBy: self.me.id,
            },
          },
        });
        if (!response) {
          throw "Something went wrong when creating the organisation!";
        }
        if (response.errors && response.errors.length > 0) {
          throw response.errors[0];
        }
      } catch (e) {
        throw e.message;
      }
    },
    async createOrganisation() {
      const self = this;
      try {
        const response = await self.$apollo.mutate({
          mutation: gql`
            mutation createOrganisation(
              $organisation: OrganisationCreateInput!
            ) {
              createOrganisation(organisation: $organisation) {
                id
              }
            }
          `,
          variables: {
            organisation: {
              name: self.organisationModel.name,
              createdBy: self.me.id,
            },
          },
        });

        if (!response) {
          throw "Something went wrong when creating the Organisation Item!";
        }
        if (response.errors && response.errors.length > 0) {
          throw response.errors[0];
        }
        if (response && response.data.createOrganisation) {
          self.organisationModel.id = response?.data?.createOrganisation?.id;
        }
      } catch (e) {
        throw e.message;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
